import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const Internet = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 9.066V9a5 5 0 0 0-9.522-2.137A3 3 0 0 0 4.637 8.8H4.3a3.3 3.3 0 1 0 0 6.6h12.4A3.3 3.3 0 0 0 18 9.066"
            fill="url(#internet-gradient)"
          />
          <defs>
            <radialGradient
              id="internet-gradient"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="rotate(34.16 -5.637 10.637)scale(16.9189)"
            >
              <stop offset=".248" stop-color="#11C3F0" />
              <stop offset="1" stop-color="#0743D0" />
            </radialGradient>
          </defs>
        </SVGIconRender>
  );
};

export default Internet;
